<template>
  <div class="d-flex justify-content-center align-items-center my-5">
    <b-spinner v-if="$apollo.loading" type="grow" variant="primary"/>
    <h1 v-else>Referral Jam — Dashboard!</h1>
  </div>
</template>

<script>
import DashboardQuery from '@/graphql/queries/RfjmDashboard.gql';

export default {
  name: 'ReferralJamsDashboard',
  apollo: {
    dashboard: {
      query: DashboardQuery,
      update: ({ company, user }) => ({ company, user }),
    },
  },
  metaInfo() {
    return {
      title: this.$t('navigation.dashboard'),
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Dashboards/ReferralJam.vue